<template>
  <div>
    <v-container
      fluid
      class="basket-product"
      v-if="$vuetify.breakpoint.smAndUp"
    >
      <v-row>
        <v-icon @click="removeFromBasket(item)">mdi-close-circle</v-icon>
        <v-col cols="4" class="flex-grow">
          <div class="carousel">
            <v-carousel
              hide-delimiters
              :show-arrows="item.images.length > 1"
              :height="$vuetify.breakpoint.xsOnly ? '150' : '296'"
              v-model="carousel"
              v-if="item.images.length > 0"
            >
              <v-carousel-item
                v-for="image in item.images"
                :key="image.id"
                :src="image.imageUrl"
              ></v-carousel-item>
              <!-- <discount-label count="10"></discount-label> -->
            </v-carousel>
            <v-carousel
              class="relative"
              hide-delimiters
              :show-arrows="false"
              :height="$vuetify.breakpoint.xsOnly ? '150' : '296'"
              v-model="carousel"
              v-else
            >
              <v-carousel-item
                src="https://i.stack.imgur.com/y9DpT.jpg"
              ></v-carousel-item>
              <discount-label count="10"></discount-label>
            </v-carousel>
          </div>
          <!-- <p class="sold title">Sold ({{ item.amount }})</p> -->
        </v-col>
        <v-col cols="4" class="flex-grow second">
          <h2 class="title">{{ item.name }}</h2>
          
          <p v-html="item.description"></p>
          <v-row>
            <v-col cols="6">
              Brand
            </v-col>
            <v-col cols="6">
              {{item.brand.name}}
              <!-- <v-img
                max-height="250"
                max-width="250"
                aspect-ratio="2"
                :src="item.brand"
              ></v-img> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              Estimated Delivery
            </v-col>
            <v-col cols="6">
              {{ item.esitmated_delivery.from }} ~
              {{ item.esitmated_delivery.to }} Days
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="6">
              Material
            </v-col>
            <v-col cols="6">
              {{ item.material }}
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col cols="6">
              Type Of Equipment
            </v-col>
            <v-col cols="6">
              {{ item.type }}
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col cols="6">
              Packaging
            </v-col>
            <v-col cols="6">
              {{ item.packaging }}
            </v-col>
          </v-row> -->
        </v-col>
        <v-col cols="4" class="flex-grow third">
          <v-row>
            <v-col
              cols="auto"
              class="flex-grow d-flex flex-column align-center"
            >
              <h2 class="title">Quantity</h2>
              <v-text-field
                :value="item.quantity"
                @input="changeQuantity"
                label="1"
                solo
                flat
                dense
                type="number"
                hide-details="auto"
              ></v-text-field>
              <div class="underline" @click="clearQuantity()">
                Clear
              </div>
            </v-col>
            <v-col cols="auto" class="flex-grow">
              <h2 class="title">Total</h2>
              <h2 class="cost">£{{ item.amount }}</h2>
              <!-- <p>inc. vat</p> -->
            </v-col>
            <v-col cols="auto" class="flex-grow">
              <h2 class="title">Price</h2>
              <h2 class="cost">
                £{{ (item.amount * item.quantity).toFixed(2) }}
              </h2>
              <!-- <p>inc. vat</p> -->
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-card
      class="basket-product"
      :class="{ mobile: $vuetify.breakpoint.xsOnly }"
      v-if="$vuetify.breakpoint.xsOnly"
    >
      <div class="basket-product-info">
        <div class="d-flex align-center flex-grow col-4 pa-0 mb-1">
          <v-carousel
            hide-delimiters
            :show-arrows="item.images.length > 1"
            height="150"
            v-model="carousel"
            v-if="item.images.length > 0"
          >
            <v-carousel-item
              v-for="image in item.images"
              :key="image.id"
              :src="image.imageUrl"
            ></v-carousel-item>
          </v-carousel>
          <v-carousel
            hide-delimiters
            :show-arrows="false"
            height="150"
            v-model="carousel"
            v-else
          >
            <v-carousel-item
              src="https://i.stack.imgur.com/y9DpT.jpg"
            ></v-carousel-item>
          </v-carousel>
        </div>
        <div class="basket-product-desc">
          <div class="basket-product-title">
            <span class="font-16">{{ item.name.substr(0, 14) }}...</span>
            <span class="font-18 gotham-medium"
              >£{{ (item.amount * item.quantity).toFixed(2) }}</span
            >
          </div>
          <div class="basket-product-brand">
            <v-avatar size="20">
              <v-img class="flex-grow-0" :src="item.brand.logo"></v-img>
            </v-avatar>
            <span>Shofu</span>
          </div>
          <div class="basket-product-details">
            <div>
              <span>Estimated Delivery:</span>
              <span>1-2 Days</span>
            </div>
            <div>
              <span>Material:</span>
              <span>Stainless Steel</span>
            </div>
            <div>
              <span>Type Of Equipment:</span>
              <span>Dental Laser</span>
            </div>
            <div>
              <span>Packaging:</span>
              <span>Packet</span>
            </div>
          </div>
        </div>
      </div>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between">
        <div class="basket-product-quantity">
          <v-btn
            class="pa-0 font-25"
            min-width="25"
            height="25"
            outlined
            color="#aaaaaa"
            @click="changeQuantity(item.quantity - 1)"
            >-</v-btn
          >
          <span class="px-4 gotham-medium">{{ item.quantity }}</span>
          <v-btn
            class="pa-0 font-25"
            min-width="25"
            height="25"
            color="#FF6B6B"
            elevation="0"
            @click="changeQuantity(item.quantity + 1)"
            dark
            >+</v-btn
          >
        </div>
        <v-btn icon class="basket-product-remove">
          <v-img
            min-height="20"
            min-width="18"
            :src="require('@/assets/basket-product-remove.svg')"
          ></v-img>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import DiscountLabel from "@/components/Shared/DiscountLabel/DiscountLabel.vue";
export default {
  name: "BasketCard",
  props: {
    item: Object
  },
  components: {
    DiscountLabel
  },
  data: () => ({
    count: 0,
    carousel: 0
  }),
  methods: {
    changeQuantity(val) {
      if (val !== 0) {
        this.$store.commit("product/changeQuantity", {
          value: val,
          product: this.item
        });
      }
    },
    removeFromBasket(item) {
      this.$store.commit("product/REMOVE_PRODUCT_FROM_BASKET", item);
    }
  }
};
</script>

<style scoped lang="scss" src="./BasketCard.scss"></style>
